export default __webpack_public_path__ + "static/media/non_breed.2145a1c6.jpg";